module.exports = __webpack_public_path__ + "static/media/icon-download.8cc6c84e.svg";